<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			projectName: 'All Rights Reserved',
			author: 'Zain ul Abideen',
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div
			class="font-general-regular text-lg "
		>
			&copy; {{ copyrightDate }}.
			<span class="font-general-medium  ">
				{{ projectName }}
			</span>
			. Developed by
			<span class="font-general-medium  ">
				{{ author }}
			</span>
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
